var _path, _g;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign || function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgPlaceholderImage16X9Vived400X255(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 400,
    height: 225,
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, /*#__PURE__*/React.createElement("g", {
    fill: "none",
    fillRule: "evenodd"
  }, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#D8D8D8",
    d: "M0 0h400v225H0z"
  })), _g || (_g = /*#__PURE__*/React.createElement("g", {
    opacity: 0.6,
    fillRule: "nonzero"
  }, /*#__PURE__*/React.createElement("path", {
    fill: "#0095D4",
    d: "M230 86.052v22.23L210.001 140v-22.166z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#00A7E0",
    d: "M190.01 117.834h19.995V140H190.01z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#0095D4",
    d: "M170 86v22.23l19.999 31.717v-22.166z"
  }), /*#__PURE__*/React.createElement("path", {
    fill: "#4EC8F4",
    d: "M230 86.052h-19.999l-9.986 15.942L189.999 86H170l19.999 31.834H210z"
  }))), /*#__PURE__*/React.createElement("path", {
    fill: "#FFF",
    style: {
      mixBlendMode: "color"
    },
    d: "M0 0h400v225H0z"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgPlaceholderImage16X9Vived400X255);
export default __webpack_public_path__ + "static/media/placeholder-image_16x9_Vived_400x255.35f01d657d2d5af9d7aaf2b490901689.svg";
export { ForwardRef as ReactComponent };